/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Farm — hisobotlar (web S7): davr + guruhlash, jami kartalar,
 * foyda bo'yicha jadval, xarajat taqsimoti. */
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import * as XLSX from 'xlsx'
import Layout from '../../components/Layout'
import Loader from '../../components/common/Loader'
import { fmtMoney, useFarmLoad } from './api'

const GROUP_LABEL = { field: 'Dala', category: 'Kategoriya', month: 'Oy' }

/** Hisobotni Excel (.xlsx) faylga yuklab olish — loyihadagi mavjud
 * SheetJS uslubida (aoa_to_sheet + writeFile), yangi dependency yo'q. */
function exportExcel(r, groupBy, from, to) {
    const header = [GROUP_LABEL[groupBy] || 'Nomi']
    if (groupBy === 'field') header.push('Maydon (ga)')
    header.push('Chiqim (so‘m)', 'Kirim (so‘m)', 'Foyda (so‘m)')
    if (groupBy === 'field') header.push('1 ga xarajat (so‘m)')

    const rows = r.rows.map((row) => {
        const line = [row.name]
        if (groupBy === 'field') line.push(Number(row.areaHa || 0))
        line.push(Number(row.expense), Number(row.income), Number(row.profit))
        if (groupBy === 'field') line.push(Number(row.costPerHa || 0))
        return line
    })

    const totalLine = ['JAMI']
    if (groupBy === 'field') totalLine.push('')
    totalLine.push(Number(r.totals.expense), Number(r.totals.income), Number(r.totals.profit))
    if (groupBy === 'field') totalLine.push('')

    const aoa = [
        ['Ferma hisoboti', '', `Davr: ${from || 'boshidan'} — ${to || 'bugungacha'}`],
        [],
        header,
        ...rows,
        [],
        totalLine,
        [],
        ['Xarajatlar taqsimoti'],
        ...(r.expenseBreakdown || []).map((b) => [b.label, Number(b.amount), `${b.percent}%`]),
    ]
    const ws = XLSX.utils.aoa_to_sheet(aoa)
    ws['!cols'] = [{ wch: 24 }, { wch: 14 }, { wch: 16 }, { wch: 16 }, { wch: 16 }, { wch: 18 }]
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Hisobot')
    XLSX.writeFile(wb, `ferma_hisoboti_${new Date().toISOString().slice(0, 10)}.xlsx`)
}

function iso(d) { return d.toISOString().slice(0, 10) }

const PRESETS = [
    { key: 'month', label: 'Bu oy' },
    { key: 'year', label: 'Bu yil' },
    { key: 'all', label: 'Hammasi' },
]

export default function FarmReports() {
    const now = new Date()
    const [preset, setPreset] = useState('year')
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const [groupBy, setGroupBy] = useState('field')

    let from
    let to
    if (preset === 'month') { from = iso(new Date(now.getFullYear(), now.getMonth(), 1)); to = iso(now) }
    if (preset === 'year') { from = iso(new Date(now.getFullYear(), 0, 1)); to = iso(now) }
    if (preset === 'custom') { from = dateFrom || undefined; to = dateTo || undefined }

    const report = useFarmLoad('reports/', {
        groupBy, dateFrom: from, dateTo: to,
    }, [groupBy, preset, dateFrom, dateTo])
    const r = report.data

    return (
        <Layout>
            <nav className="breadcrumb mb-3" aria-label="breadcrumbs">
                <ul>
                    <li><Link to="/farm">Dala boshqaruvi</Link></li>
                    <li className="is-active"><a href="#!">Hisobotlar</a></li>
                </ul>
            </nav>
            <h1 className="title is-4">Ferma hisobotlari</h1>

            <div className="is-flex is-align-items-center is-flex-wrap-wrap mb-4" style={{ gap: 8 }}>
                {PRESETS.map((p) => (
                    <button key={p.key} type="button"
                        className={`button is-small ${preset === p.key ? 'is-link' : 'is-light'}`}
                        onClick={() => setPreset(p.key)}>{p.label}</button>
                ))}
                <input className="input is-small" type="date" style={{ width: 150 }}
                    value={dateFrom}
                    onChange={(e) => { setDateFrom(e.target.value); setPreset('custom') }} />
                <span>—</span>
                <input className="input is-small" type="date" style={{ width: 150 }}
                    value={dateTo}
                    onChange={(e) => { setDateTo(e.target.value); setPreset('custom') }} />
                <div className="select is-small ml-4">
                    <select value={groupBy} onChange={(e) => setGroupBy(e.target.value)}>
                        <option value="field">Dala bo‘yicha</option>
                        <option value="category">Kategoriya bo‘yicha</option>
                        <option value="month">Oy bo‘yicha</option>
                    </select>
                </div>
                <div className="ml-auto is-flex" style={{ gap: 8 }}>
                    <button type="button" className="button is-small is-success is-light"
                        disabled={!r}
                        onClick={() => exportExcel(r, groupBy, from, to)}>
                        <i className="icon ion-md-download mr-1" /> Excel
                    </button>
                    <button type="button" className="button is-small is-light"
                        disabled={!r}
                        onClick={() => window.print()}>
                        <i className="icon ion-md-print mr-1" /> Chop etish / PDF
                    </button>
                </div>
            </div>

            {report.loading && <Loader center large />}
            {!report.loading && report.error && (
                <div className="box has-text-centered py-6">
                    <p className="has-text-grey">
                        {report.error.status === 403
                            ? 'Moliyaviy hisobotlar sizning rolingizga ochiq emas.'
                            : 'Hisobotni yuklab bo‘lmadi — qayta urinib ko‘ring.'}
                    </p>
                </div>
            )}
            {!report.loading && r && (
                <>
                    <div className="columns">
                        <TotalCard title="Jami chiqim" value={r.totals.expense} color="has-text-danger" />
                        <TotalCard title="Jami kirim" value={r.totals.income} color="has-text-success" />
                        <TotalCard title="Foyda" value={r.totals.profit}
                            color={r.totals.profit >= 0 ? 'has-text-success' : 'has-text-danger'} />
                    </div>

                    <div className="box">
                        <table className="table is-fullwidth is-striped">
                            <thead>
                                <tr>
                                    <th>{groupBy === 'month' ? 'Oy' : groupBy === 'category' ? 'Kategoriya' : 'Dala'}</th>
                                    {groupBy === 'field' && <th className="has-text-right">Maydon (ga)</th>}
                                    <th className="has-text-right">Chiqim</th>
                                    <th className="has-text-right">Kirim</th>
                                    <th className="has-text-right">Foyda</th>
                                    {groupBy === 'field' && <th className="has-text-right">1 ga xarajat</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {r.rows.map((row) => (
                                    <tr key={`${row.id}-${row.name}`}>
                                        <td>
                                            {groupBy === 'field' && row.id
                                                ? <Link to={`/farm/fields/${row.id}`}><b>{row.name}</b></Link>
                                                : <b>{row.name}</b>}
                                        </td>
                                        {groupBy === 'field' && (
                                            <td className="has-text-right">{row.areaHa ?? '—'}</td>
                                        )}
                                        <td className="has-text-right">{fmtMoney(row.expense)}</td>
                                        <td className="has-text-right">{fmtMoney(row.income)}</td>
                                        <td className={`has-text-right has-text-weight-bold ${Number(row.profit) >= 0 ? 'has-text-success' : 'has-text-danger'}`}>
                                            {fmtMoney(row.profit)}
                                        </td>
                                        {groupBy === 'field' && (
                                            <td className="has-text-right">
                                                {row.costPerHa ? fmtMoney(row.costPerHa) : '—'}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                {r.rows.length === 0 && (
                                    <tr><td colSpan={6} className="has-text-centered has-text-grey py-4">
                                        Tanlangan davrda ma‘lumot yo‘q.
                                    </td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {(r.expenseBreakdown || []).length > 0 && (
                        <div className="box">
                            <h3 className="title is-6 mb-2">Xarajatlar taqsimoti</h3>
                            <table className="table is-fullwidth">
                                <tbody>
                                    {r.expenseBreakdown.map((b) => (
                                        <tr key={b.label}>
                                            <td style={{ width: 180 }}>{b.label}</td>
                                            <td>
                                                <progress className="progress is-small is-warning mb-0"
                                                    value={b.percent} max="100" style={{ marginTop: 6 }} />
                                            </td>
                                            <td className="has-text-right" style={{ width: 180 }}>
                                                {fmtMoney(b.amount)} <span className="has-text-grey is-size-7">({b.percent}%)</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </>
            )}
        </Layout>
    )
}

function TotalCard({ title, value, color }) {
    return (
        <div className="column">
            <div className="box has-text-centered">
                <p className="is-size-7 has-text-grey">{title}</p>
                <p className={`is-size-4 has-text-weight-bold ${color}`}>{fmtMoney(value)} so‘m</p>
            </div>
        </div>
    )
}
